import UsersProvider from './UsersContext';
import Users from './Users';

let Index = () => {
    return (
        <UsersProvider>
            <Users />
        </UsersProvider>
    )
}

export default Index;